/**
 * 公开站(mzgames.cn)运维 API client.
 * 后端: src/Cat.Api/Controllers/Admin/PublicSiteAdminController.cs
 */
import { apiGet, apiPost } from './http';

export type PublicSiteBuildStatus = 'Pending' | 'Running' | 'Succeeded' | 'Failed';
export type SchedulerState = 'idle' | 'pending' | 'building';

export interface PublicSiteBuildItem {
  id: string;
  status: PublicSiteBuildStatus;
  triggerReason: string;
  startedAt: string;        // ISO 8601
  finishedAt?: string | null;
  durationMs?: number | null;
  attemptCount: number;
  errorMessage?: string | null;
}

export interface PublicSiteStatusDto {
  schedulerState: SchedulerState;
  pendingReasonCount: number;
  lastRequestAt?: string | null;
  recentBuilds: PublicSiteBuildItem[];
}

/** 拉当前调度状态 + 最近 N 条构建记录 */
export function getPublicSiteStatus(recentCount = 5): Promise<PublicSiteStatusDto> {
  return apiGet<PublicSiteStatusDto>(`/api/admin/public-site/status?recentCount=${recentCount}`);
}

/** 立即重建(跳过去抖). reason 可选 */
export function triggerPublicSiteRebuild(reason?: string): Promise<void> {
  return apiPost<void>('/api/admin/public-site/rebuild', { reason });
}
